export const en = {
  //NEWSLETTER SECTION
  your_email_address: 'Your e-mail address',
  sign_up: 'Sign up',
  invalid_email_message:
    'Incorrent e-maill. Must contain @ sign and min. 2 signs after dot. E.g.: email@example.com',
  //HOTEL DESCRIPTIONS SECTION
  choose_country: 'Choose country',
  countries: 'Countries',
  regions: 'Regions',
  all: 'All',
  filter: 'Filtruj',
  operators: 'Operators',
  original_description: 'Original description',
  description_translated: 'Description translated by google',
  loading: 'Loading...',
  descriptions: 'Descriptions',
  excluding_owner: 'Other than Amigos',
  only_owner: 'Only by Amigos',
  description: 'Description',
  terms_and_prices: 'Terms and prices',
  check_offer: 'Check availability',
  // ADMIN SPECIAL OFFERS
  admin_special_offers_supplier: 'Supplier',
  //RESERVATIONS SECTION

  //COMMON
  from: 'from',
  no_offers_found: 'We did not find matching offers...',
  dont_be_worried: 'But do not worry, we have 860 thousand more of them.',
  change_filters: 'Change search parameters',
  offers_list_error: 'Sorry, an error occurred :( ',
  refresh_page: 'Please, refresh the page or try again later.',
};



// WEBPACK FOOTER //
// ./common/locale/en.js